<template>
    <div :class="templateClass">
        <div class="row top">
            <img class="espa" src="@/assets/espa-banner.png" v-if="!isAuthenticated" />
           <div class="row">
                <div class="col-md-12">
                <h4><u>Επιβεβαίωση Παρουσιών</u></h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 col-md-offset-2">
                    <div class="alert alert-success" role="alert" v-if="this.success">{{message}}</div>
                    <div class="alert alert-danger" role="alert" v-if="!this.success">{{message}}</div>
                   <p> </p>
                </div>
            </div>
        </div>
        <app-footer v-if="!isAuthenticated" />
    </div>
</template>
<script>
import mainService from "../../services/mainService";
import Footer from "../footer/footer.vue";
export default {
  props: ["token"],
  inject:['mySpinner'],
  components: {
    "app-footer": Footer,
  },
  data() {
    return {
      link: "",
      message:"",
      success:false,
      templateClass: "container",
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  created() {
    this.link = this.$route.query.token;
  },
  async mounted(){
      try{
          if(this.link != ""){
            this.mySpinner.val=true;

            var _res = await mainService.get(`/Verifications/VerifyParentsAttendances?verificationLink=${this.link}`);

            if(_res.data.success){
                this.mySpinner.val=false;
                this.success = true;
                this.message = "Οι παρουσίες επιβεβαιώθηκαν επιτυχώς, ευχαριστούμε!";
            }else{
               this.mySpinner.val=false;
                this.message = _res.data.message
            }        
        }
       } catch (error) {
          this.mySpinner.val=false;
          this.message = "Συνέβει κάποιο σφάλμα, παρακαλούμε προσπαθήστε αργότερα";
      }
      
  }
};
</script>
<style lang="scss" scoped>
.topic{
  text-align: left;
}
.espa {
  max-width: 90vw;
  margin: 1em 0;
}

.container .page-title,
.container .row.top {
  margin: 1rem 0;
  text-align: center;
}

.out::v-deep {
  float: right !important;
  .generic-button {
    left: 0px !important;
  }
}

</style>